import { Link } from "react-router-dom";
import { Phone, MessageSquare, Star } from "lucide-react";
import { BUSINESS } from "../lib/data";

export const StarRating = ({ count = 5, className = "" }) => (
  <div className={`flex items-center gap-0.5 ${className}`} aria-label={`${count} out of 5 stars`}>
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-secondary text-secondary" />
    ))}
  </div>
);

export const CTABand = () => (
  <section className="relative overflow-hidden bg-primary px-5 py-20 md:px-10">
    <div
      className="pointer-events-none absolute inset-0 opacity-20 mix-blend-screen"
      style={{
        backgroundImage:
          "url(https://images.pexels.com/photos/21802567/pexels-photo-21802567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="relative mx-auto max-w-4xl text-center">
      <h2 className="font-heading text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl">
        Let us lighten the load
      </h2>
      <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/85">
        Book your free home visit. We'll see your space in person before sharing any
        pricing — no obligation, no surprises. Just a cleaner home and more breathing room.
      </p>
      <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <a
          href={BUSINESS.phoneHref}
          data-testid="cta-call-button"
          className="group flex w-full items-center justify-center gap-2 rounded-full bg-white px-8 py-4 font-semibold text-primary shadow-lg transition-all duration-300 hover:-translate-y-0.5 sm:w-auto"
        >
          <Phone className="h-5 w-5 transition-transform duration-300 group-hover:rotate-12" /> Let's Talk
        </a>
        <Link
          to="/contact"
          data-testid="cta-message-button"
          className="group flex w-full items-center justify-center gap-2 rounded-full border-2 border-white/70 px-8 py-4 font-semibold text-white transition-all duration-300 hover:bg-white/10 hover:-translate-y-0.5 sm:w-auto"
        >
          <MessageSquare className="h-5 w-5" /> Send a Message
        </Link>
      </div>
    </div>
  </section>
);
